import { DashboardSectionCollapsible } from '@g17eco/molecules/dashboard';
import { QuestionInformation } from '../survey/question/QuestionInformation';
import { TrackerInformation } from './components/TrackerInformation';
import { useToggle } from '../../hooks/useToggle';
import UniversalTrackerClassInterface from '../../model/UniversalTrackerClassInterface';

interface Props {
  utr: UniversalTrackerClassInterface;
  alternativeCode?: string;
}
export const CollapsibleQuestionInfo = ({ utr, alternativeCode }: Props) => {
  const [isCollapsed, toggle] = useToggle(true);

  const classes = {
    valueLabel: 'text-lg',
    instructions: 'text-sm',
    instructionsLink: 'xs',
  };

  return (
    <DashboardSectionCollapsible
      isCollapsed={isCollapsed}
      toggleCollapse={toggle}
      className={isCollapsed ? 'question-info-collapsed' : 'question-info'}
      title={utr.getName()}
    >
      <QuestionInformation utr={utr} alternativeCode={alternativeCode ?? ''} classes={classes} />
      <TrackerInformation utr={utr} />
    </DashboardSectionCollapsible>
  );
};
